import React, { Component } from 'react';
import Footer from './../Footer/Footer';
import s from './PageContent.module.css';

export default class PageContent extends Component {
  render() {
    return (
      <div className={s.Content}>
        {/* <!-- /.content-wrapper--> */}
        <div className="content-wrapper">
          {/* Breadcrumbs*/}
          <div className="container-fluid">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <h4>Заголовок страницы</h4>
              </li>
            </ol>
            <div>{this.props.children}</div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
